import { createContext, useContext } from 'react';
import type { useHeader } from '~/components/layout/Header/useHeader';

type HeaderContextValue = ReturnType<typeof useHeader> & {
  variant: 'light' | 'dark';
  wrapLogoInH1?: boolean;
};

const HeaderContext = createContext<HeaderContextValue | null>(null);

export const HeaderProvider = HeaderContext.Provider;

export const useHeaderContext = (): HeaderContextValue => {
  const ctx = useContext(HeaderContext);
  if (!ctx) throw new Error('useHeaderContext must be used within a Header');
  return ctx;
};
